import { Component } from '@angular/core';

interface SocialLink {
  title: string;
  url: string;
  svgPath: string;
}

const SOCIAL_LINKS: readonly SocialLink[] = [
  {
    title: 'Kaizenic on X',
    url: 'https://twitter.com/kaizenic',
    svgPath:
      'M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-4.714-6.231-5.401 6.231H2.744l7.73-8.835L1.254 2.25H8.08l4.252 5.622zm-1.161 17.52h1.833L7.084 4.126H5.117z',
  },
  {
    title: 'Kaizenic on LinkedIn',
    url: 'https://linkedin.com/company/kaizenic',
    svgPath:
      'M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z',
  },
];

@Component({
  selector: 'app-footer',
  standalone: true,
  template: `
    <footer class="footer">
      <div class="footer-inner">
        <!-- Top row: logo + socials -->
        <div class="footer-top">
          <a href="/" class="footer-logo">
            K<span class="footer-logo-accent">ΛI</span>ZENIC
          </a>
          <div class="footer-socials">
            @for (social of socialLinks; track social.title) {
              <a
                class="social-btn"
                [href]="social.url"
                [title]="social.title"
                target="_blank"
                rel="noopener noreferrer"
              >
                <svg viewBox="0 0 24 24" [attr.aria-label]="social.title">
                  <path [attr.d]="social.svgPath" />
                </svg>
              </a>
            }
          </div>
        </div>

        <!-- Bottom row: legal links + copyright -->
        <div class="footer-bottom">
          <nav class="footer-links" aria-label="Legal">
            <a href="/privacy">Privacy Policy</a>
            <a href="/terms">Terms of Service</a>
            <a href="mailto:hello@kaizenic.ai">Contact</a>
          </nav>
          <span class="footer-copy"
            >&copy; {{ currentYear }} Kaizenic Inc.</span
          >
        </div>
      </div>
    </footer>
  `,
  styleUrl: './footer.component.scss',
})
export class FooterComponent {
  readonly currentYear = new Date().getFullYear();
  readonly socialLinks = SOCIAL_LINKS;
}
